import { DialogProps, FormDialog } from '../../shared/ui/form-dialog';
import { PopupFormData } from './sales-departments-create-edit.form';
import { UsersMultiPickerField } from '../../shared/ui/formik-fields/users-multi-picker-field';
import { UserPickerField } from '../../features/user/user-picker';
import { SalesDepartmentDto } from '@sr/dto';
import { Stack } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';

type SalesDepartmentDialogProps = Readonly<{
  dialogProps: Omit<DialogProps<PopupFormData>, 'renderForm' | 'renderTitle'>;
  itemToEdit: SalesDepartmentDto | null;
}>;
export const SalesDepartmentDialog = ({ dialogProps, itemToEdit }: SalesDepartmentDialogProps) => {
  return (
    <FormDialog<PopupFormData>
      {...dialogProps}
      renderTitle={!itemToEdit ? 'Новый отдель продаж' : 'Отдел продаж'}
      renderForm={(props) => {
        return (
          <Stack sx={{ width: '500px' }}>
            <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
              <Field required name="title" component={TextField} label="Название отдела продаж" fullWidth />
              <Field required name="employees" component={UsersMultiPickerField} fullWidth label={'Сотрудники'} />
              <Field name={'managerId'} component={UserPickerField} label={'Руководитель отдела'} clearable />
              <Field name={'plan'} component={TextField} label={'План отдела продаж'} />
              <Field name={'planFulfillmentPercentage'} component={TextField} label={'% от продаж при выполнении плана'} />
              <Field name={'planNonFulfillmentPercentage'} component={TextField} label={'% от продаж при не выполнении плана'} />
            </Stack>
          </Stack>
        ); 
      }}
    />
  );
};
